<template>
	<header class="header-bar">
		<div>
			<div class="logo">
				<router-link to="/" class="home" aria-label="go to home page"></router-link>
			</div>
			<h1>web audio explained</h1>
		</div>
		<nav>
			<router-link :class="hasPreviousPage() ? '' : 'disabled'" :to="previousPage()">Prev</router-link>
			<router-link :class="hasNextPage() ? '' : 'disabled'" :to="nextPage()">Next</router-link>
			<div class="count"><span>{{currentPageNumber()+1}}</span><span class="total"> of <span>{{totalPageCount()}}</span></span></div>
		</nav>
		<section class="shortcut-actions">
			<button v-shortkey="['arrowright']" @shortkey="next()" v-if="hasNextPage()"></button>
			<button v-shortkey="['space']" @shortkey="next()" v-if="hasNextPage()"></button>
			<button v-shortkey="['arrowleft']" @shortkey="prev()" v-if="hasPreviousPage()"></button>
			<button v-shortkey="['f5']" @shortkey="notes()"></button>
		</section>

	</header>
</template>

<script>
	import {mapGetters, mapActions} from "vuex";

	export default {
		name: "header-bar",
		methods: {
			...mapGetters(['previousPage', 'nextPage', 'hasPreviousPage', 'hasNextPage', 'currentPageNumber', 'totalPageCount']),
			...mapActions(['toggleNotes']),
			prev() {
				this.$router.push(this.previousPage());
			},
			next() {
				this.$router.push(this.nextPage());
			},
			notes() {
				this.toggleNotes();
			}
		},
	}
</script>

<style lang="scss" scoped>
	header {
		height: 50px;
		width: calc(100% - 20px);
		padding: 10px;
		display: flex;
		justify-content: space-between;
		background-color: $header-background;
		font-size: 22px;
	}
	.logo {
		background-image: url("../assets/images/abcjs_logo.svg");
		background-repeat: no-repeat;
		background-size: cover;
		font-family: 'Inconsolata', monospace;
		height: 50px;
		width: 473px;
		position: absolute;
		top: 0;
		max-width: calc(100% - 20px);
	}
	.home {
		display: inline-block;
		width: 100px;
		height: 50px;
		margin-left: 20px;
	}
	h1 {
		position: absolute;
		top: 25px;
		left: 20px;
		color: $title-color;
		text-shadow: $title-shadow;
		font-size: 1em;
	}
	nav {
		display: flex;
		justify-content: space-between;
		width: 170px;
		align-items: center;
		z-index: 5;

		a {
			border-radius: 4px;
			padding: 0 10px;
			box-shadow: $button-shadow;
			text-decoration: none;
			background: #ffffff;
			margin-bottom: 20px;
			color: #000000;

			&:hover {
				background: $button-hover-background;
			}
		}
	}
	.count {
		width: 25px;
		background: #f3f2ef;
	}
	.total {
		display: none;
	}
	.disabled {
		opacity: 0;
		pointer-events: none;
	}
	@media screen and (min-width: 740px) {
		h1 {
			font-size: 36px;
			margin: 2px 0 0 120px;
			top: inherit;
			left: inherit;
		}
		.logo {
			top:11px;
		}
		.count {
			width: 90px;
		}
		.total {
			display: inline;
		}
		nav {
			width: 240px;

			a {
				margin-bottom: 0;
			}
		}
	}
</style>
